
import { defineComponent, watch } from 'vue'
import { mapGetters } from "vuex";
import { User } from "./models/User";
import { Config } from "./models/Config";

export default defineComponent({
  name: "App",
  computed: {
    ...mapGetters({
      User: "userstate/getUser",
      AdminCookie: "userstate/getAdminCookie",
    }),
  },
  data() {
    return {
      Title: "API Documentation",
      HideNav: false,
      swaggerUrl: "",
      config: require("../config.json") as Config,
    }
  },
  async beforeMount() {
    this.swaggerUrl = this.config.apiUrl;
    if (this.User && this.User.isLoggedIn && this.AdminCookie) {
      await this.$store.dispatch("createAxiosService", { isAdmin: true, adminCookie: this.AdminCookie });
    }
    else {
      this.$store.dispatch("createAxiosService", { isAdmin: false, adminCookie: "" });
    }
  },
  methods: {
    login() {
      if (!window.location.pathname.includes('/auth/login'))
        this.$router.push({ name: "Login" });
    },
    async logout() {
      this.$store.state.axiosService.Logout()
        .catch((response: any) => {
          console.log("Error logging out.");
        })
        .finally(() => {
          this.$store.dispatch('userstate/setUser', new User("", "", "", false));
          this.$store.dispatch("createAxiosService", { isAdmin: false, adminCookie: "" });
          this.$store.dispatch('userstate/setAdminCookie', "");
          this.navigateToRoute('/docs/intro');
        });
    },

    sendToSwagger() {
      window.open(this.swaggerUrl, '_blank');
    },

    navigateToRoute(routePath: string) {
      this.$router.push({ path: routePath }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
            throw err;
        }
      });
    }
  }
})
